import { z } from "zod";

// t("CASH")
// t("CREDIT_CARD")
// t("CHECK")
// t("CREDIT_BALANCE")

export const paymentMethodsEnum = z.enum([
  "CASH",
  "CREDIT_CARD",
  "CHECK",
  "CREDIT_BALANCE",
]);

export type PaymentMethod = z.infer<typeof paymentMethodsEnum>;
